<div class="slider">
  <div class="slider__label">{{ displayValue() }} dni</div>
  <ion-range [min]="min()" [max]="max()" [value]="value()" (ionInput)="onInput($event)"> </ion-range>
  <div class="slider__markers">
    <span>{{ min() }}</span>
    <span>7</span>
    <span>14</span>
    <span>21</span>
    <span>{{ max() }}</span>
  </div>
</div>
